<svg
  width="23"
  height="3"
  viewBox="0 0 23 3"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M21.5749 2.15H1.77495C1.31955 2.15 0.949951 1.7804 0.949951 1.325C0.949951 0.8696 1.31955 0.5 1.77495 0.5H21.5749C22.0303 0.5 22.4 0.8696 22.4 1.325C22.4 1.7804 22.0303 2.15 21.5749 2.15Z"
    fill="currentColor"
  />
</svg>
